import * as React from 'react';
import Cropper, { ReactCropperElement } from 'react-cropper';
// const Cropper = require('react-cropper');
import { ICropperOptions } from 'models/common';
import { Slider } from 'components';

import 'cropperjs/dist/cropper.css';
import renderIcon from 'helpers/renderIcon';

interface IProps {
	cropOptions?: ICropperOptions;
	imageUrl: string;
}

interface IState {
	min?: number;
	max?: number;
	step?: number;
	value?: number;
}

class CropTool extends React.Component<IProps, IState> {
	private cropperRef: React.RefObject<ReactCropperElement>;

	constructor(props) {
		super(props);

		this.crop = this.crop.bind(this);
		this.zoomTo = this.zoomTo.bind(this);
		this.cropReady = this.cropReady.bind(this);

		this.cropperRef = React.createRef<ReactCropperElement>();

		this.state = {
			value: props.initialValue ? props.initialValue : 0,
			min: props.min ? props.min : 0,
			max: props.max ? props.max : 1,
			step: props.step ? props.step : 0.1,
		};
	}

	private get cropper() {
		return this.cropperRef.current?.cropper;
	}

	private crop() {
		const data: Cropper.Data = this.cropper.getData();
		this.props.cropOptions.croppedImageCallback({
			x: data.x,
			y: data.y,
			width: data.width,
			height: data.height,
			rotate: data.rotate,
		});
	}

	private cropReady() {
		const imageData = this.cropper?.getImageData();
		const cropBoxData = this.cropper?.getCropBoxData();
		const canvasData = this.cropper?.getCanvasData();

		let min = Math.round((cropBoxData.width / imageData.width + 0.00001) * 10) / 10;
		let value = Math.round((canvasData.width / imageData.width + 0.00001) * 10) / 10;
		let max = Math.round(((cropBoxData.width / imageData.width) * 2 + 0.00001) * 10) / 10;

		if (imageData.width > imageData.height) {
			min = Math.round((cropBoxData.height / imageData.height + 0.00001) * 10) / 10;
			value = Math.round((canvasData.height / imageData.height + 0.00001) * 10) / 10;
			max = Math.round(((cropBoxData.height / imageData.height) * 2 + 0.00001) * 10) / 10;
		}

		this.setState({ min, max, step: 0.1, value });
	}

	private zoomTo(ratio: number) {
		this.cropper?.zoom(ratio);
	}

	private rotate = () => {
		this?.cropper?.rotate(90);
	};

	public render() {
		const { cropOptions, imageUrl } = this.props;

		const initialAspectRatio = typeof cropOptions.aspectRatio === 'undefined' ? undefined : cropOptions.aspectRatio;

		return (
			<div className="cropWrapper">
				<Cropper
					ref={this.cropperRef}
					src={imageUrl}
					crop={this.crop}
					ready={this.cropReady}
					initialAspectRatio={initialAspectRatio}
					{...cropOptions}
				/>
				<div className={`cropperOptionsHolder ${cropOptions?.rotatable ? 'multipleElements' : ''}`}>
					{cropOptions?.showSlider ? (
						<Slider
							sliderCallback={this.zoomTo}
							min={this.state.min}
							max={this.state.max}
							step={this.state.step}
							initialValue={this.state.value}
						/>
					) : null}
					{cropOptions?.rotatable &&
						renderIcon('recurringEvent', 24, 24, 'cropperRotateButton', () => {
							this.rotate();
						})}
				</div>
			</div>
		);
	}
}
export { CropTool };
